import i18n from "i18next";
import LanguageDetector from "i18next-browser-languagedetector";
import { initReactI18next } from "react-i18next";

import Backend from "i18next-http-backend";

i18n.use(LanguageDetector).use(initReactI18next).use(Backend).init({
  // lng: "en",
  // debug: true,
  returnObjects: true,
  // Plural keys (`_one` / `_other`) need a fallback language in locales
  // that carry no entry; plain sentence keys are unaffected.
  fallbackLng: "en",
});
